<textarea [formControlName]="question.key"
          [ngClass]="{'is-invalid': !isValid}"
          class="form-control"
          [id]="question.key"
          [required]="question.required"
          [placeholder]="question.placeholder"
          rows="10">
</textarea>
